import type { NonCustomOnboardingTourStepOption } from 'models';
import { useMemo } from 'react';

export const useSupportedStepDescription = ({ step }: { step: NonCustomOnboardingTourStepOption }) =>
  useMemo(() => {
    switch (step) {
      case 'consents':
        return 'To continue, please read and agree to our standard consents.';
      case 'profile':
        return 'Express yourself with a profile picture! Your phone number, date of birth, and timezone are only shared with your organization’s administrators.';
    }
  }, [step]);
